
/* global $,productBasePriceTaxExcl,baseUnitPrice:true,productUnitPriceRatio,currency,specific_currency,customerGroupWithoutTax,noTaxForThisProduct,currencyRate,ecotaxTax_rate,taxRate,productPriceTaxIncluded,groupReduction,productPriceTaxExcluded,productReference,availableLaterValue,doesntExist,doesntExistNoMore,doesntExistNoMoreBut,quantitiesDisplayAllowed,maxQuantityToAllowDisplayOfLastQuantityMessage,allowBuyWhenOutOfStock,availableNowValue,stock_management,productAvailableForOrder,gtagData,combinations,default_eco_tax,oosHookJsCodeFunctions,attributeCombinations,quantityAvailable:true,ad,adtoken,document,window,customizationFields:true,id_product,combinationImages:true,combinations:true,minimalQuantity,productHasAttributes,currencyFormat,currencySign,currencyBlank,baseDir */

import tools from '../scripts/tools';
import vars from '../scripts/variables';
import responsive from '../scripts/responsive';
require('../style/components/product/async.scss');

require('../scripts/responsive');
require('../scripts/rating');
require('../scripts/inputs');
require('../scripts/owl.carousel');
require('../scripts/select2');
require('../scripts/jquery.touchSwipe');
require('velocity-animate');
require('../../../../../klip_delivery_date/views/js/deliverybox.js');
const PerfectScrollbar = require('../scripts/perfectScrollbar.js');
// require('./jquery.magnific-popup.min.js');

var myImg = 500;
if(document.body.clientWidth < 993){
    var myImg = 362;
}

if(document.body.clientWidth < 767){
    var myImg = 240;
}

var maxImages = $('.current-img').length;

var blockImg = (myImg*maxImages)+10;
if(document.body.clientWidth < 993){
    $('.product-gallery-img-content').css('width',blockImg+'px');
}


if(document.body.clientWidth <= 991){
    $('.box-info-product .quantity_wanted-wrap input').attr("id","quantity_wanted_no_active");
    $('.stickyBlock-left .quantity_wanted-wrap input').attr("id","quantity_wanted");
}else{
    $('.box-info-product .quantity_wanted-wrap input').attr("id","quantity_wanted");
    $('.stickyBlock-left .quantity_wanted-wrap input').attr("id","quantity_wanted_no_active");
}

$(window).resize(function(){

    if(document.body.clientWidth > 993){
        var blockImg = 500;
        $('.product-gallery-img-content').css('width',blockImg+'px');

    }

    if(document.body.clientWidth <= 991){
        $('.box-info-product .quantity_wanted-wrap input').attr("id","quantity_wanted_no_active");
        $('.stickyBlock-left .quantity_wanted-wrap input').attr("id","quantity_wanted");
    }else{
        $('.box-info-product .quantity_wanted-wrap input').attr("id","quantity_wanted");
        $('.stickyBlock-left .quantity_wanted-wrap input').attr("id","quantity_wanted_no_active");
    }


});

var IMG_WIDTH = myImg;
var currentImg = 0;

var speed = 500;
var imgs = $(".product-gallery-img-content");

const $document = $(document);
const $body = $(document.body);
const $window = $(window);
const $buyBlock = $('#buy_block');
const click = 'click';
const change = 'change';

class Product {

    constructor() {
        $('.onlyone').closest('.product_attributes').css({
            'margin-top': 0,
            'padding-top': 0
        });
        $('.onlyone').closest('#attributes').css({
            'margin-bottom': 0,
            'padding-top': 0
        });


        if ($("#perfumeBox-content").length != 0){
            this.iniParfumSelect();
        }

        this.galleryFadeSpeed = vars.galleryFadeSpeed;

        this.slider = null;

        this.selectedCombination = [];
        this.globalQuantity = 0;
        this.colors = [];
        this.original_url = `${window.location}`;
        this.first_url_check = true;
        this.firstTime = true;
        this.manualChange = false;
        this.postedToAnalytics = false;
        this.postedToFbAnalytics = false;

        this.combinationImagesJS = [];
        this.combinationsJS = [];
        this.combinationsHashSet = [];
        this.basePriceDisplay = [];
        this.priceWithDiscountsDisplay = [];
        this.$gallery = $('.pb-gallery');

//        import(/* webpackPreload: true, webpackChunkName: "gallery" */'./gallery').then(({ default: gallery }) => {
//            this.gallery = gallery;
//            this.gallery.update(this.currentCombination, true);
//        });


        if (typeof customizationFields !== 'undefined' && customizationFields) {
            const customizationFieldsBk = customizationFields;
            customizationFields = [];
            let j = 0;
            for (let i = 0; i < customizationFieldsBk.length; ++i) {
                const key = `pictures_${parseInt(id_product, 10)}_${parseInt(customizationFieldsBk[i].id_customization_field, 10)}`;
                customizationFields[i] = [];
                customizationFields[i][0] = (parseInt(customizationFieldsBk[i].type, 10) === 0) ? `img${i}` : `textField${j++}`;
                customizationFields[i][1] = (parseInt(customizationFieldsBk[i].type, 10) === 0 && customizationFieldsBk[i][key]) ? 2 : parseInt(customizationFieldsBk[i].required, 10);
            }
        }

        if (typeof combinationImages !== 'undefined' && combinationImages) {
            this.combinationImagesJS = [];
            this.combinationImagesJS[0] = [];
            let k = 0;
            for (const i in combinationImages) {
                this.combinationImagesJS[i] = [];
                for (const j in combinationImages[i]) {
                    const idImage = parseInt(combinationImages[i][j].id_image, 10);
                    if (idImage) {
                        this.combinationImagesJS[0][k++] = idImage;
                        this.combinationImagesJS[i][j] = [];
                        this.combinationImagesJS[i][j] = idImage;
                    }
                }
            }
            if (typeof this.combinationImagesJS[0] !== 'undefined' && this.combinationImagesJS[0]) {
                const arrayValues = [];
                for (const key in this.arrayUnique(this.combinationImagesJS[0])) {
                    arrayValues.push(this.combinationImagesJS[0][key]);
                }
                this.combinationImagesJS[0] = arrayValues;
            }
            combinationImages = this.combinationImagesJS;
        }

        if (typeof combinations !== 'undefined' && combinations) {
            this.combinationsOriginal = { ...combinations };
            this.combinationsJS = [];
            this.combinationsHashSet = {};
            let k = 0;
            for (const i in combinations) {
                this.globalQuantity += combinations[i].quantity;
                this.combinationsJS[k] = [];
                this.combinationsJS[k].idCombination = parseInt(i, 10);
                this.combinationsJS[k].idsAttributes = combinations[i].attributes;
                this.combinationsJS[k].quantity = combinations[i].quantity;
                this.combinationsJS[k].price = combinations[i].price;
                this.combinationsJS[k].ecotax = combinations[i].ecotax;
                this.combinationsJS[k].image = parseInt(combinations[i].idImage, 10);
                this.combinationsJS[k].reference = combinations[i].reference;
                this.combinationsJS[k].unit_price = combinations[i].unit_impact;
                this.combinationsJS[k].minimal_quantity = parseInt(combinations[i].minimal_quantity, 10);
                this.combinationsJS[k].description = combinations[i].lang == null ? false : (combinations[i].lang.description.length > 0 ? combinations[i].lang.description : false);

                this.combinationsJS[k].available_date = [];
                this.combinationsJS[k].available_date.date = combinations[i].available_date;
                this.combinationsJS[k].available_date.date_formatted = combinations[i].date_formatted;

                this.combinationsJS[k].specific_price = [];
                this.combinationsJS[k].specific_price.reduction_percent = (combinations[i].specific_price && combinations[i].specific_price.reduction && combinations[i].specific_price.reduction_type === 'percentage') ? combinations[i].specific_price.reduction * 100 : 0;
                this.combinationsJS[k].specific_price.reduction_price = (combinations[i].specific_price && combinations[i].specific_price.reduction && combinations[i].specific_price.reduction_type === 'amount') ? combinations[i].specific_price.reduction : 0;
                this.combinationsJS[k].price = (combinations[i].specific_price && combinations[i].specific_price.price && parseInt(combinations[i].specific_price.price, 10) !== -1) ? combinations[i].specific_price.price : combinations[i].price;

                this.combinationsJS[k].reduction_type = (combinations[i].specific_price && combinations[i].specific_price.reduction_type) ? combinations[i].specific_price.reduction_type : '';
                this.combinationsJS[k].id_product_attribute = (combinations[i].specific_price && combinations[i].specific_price.id_product_attribute) ? combinations[i].specific_price.id_product_attribute : 0;
                this.combinationsJS[k].attributes_values = combinations[i].attributes_values;

                const key = this.combinationsJS[k].idsAttributes.sort().join('-');
                this.combinationsHashSet[key] = this.combinationsJS[k];

                k++;
            }
            combinations = this.combinationsJS;
        }
        else {
            if(typeof tagInfo !== 'undefined') {

                const data = {
                    dimension1: tagInfo.dimension1,
                    dimension2: 0,
                    dimension3: tagInfo.dimension3,
                    dimension4: productPrice,
                    dimension5: tagInfo.dimension5,
                };
            }
        }

        $document.ready(() => this.documentReady());

        this.events();
        this.imageChange();
        this.moveThumbsToMobile();
        this.popop();
        // carousels.initProductColorsSlider();

        $document.trigger('initProduct');
        $body.addClass('product_initialized');
    }


    moveThumbsToMobile() {
        const $thumbs = this.$gallery.find('#product_gallery_thumbs');

        $thumbs.data('ps', new PerfectScrollbar($thumbs[0], {
            wheelSpeed: 1,
            useBothWheelAxes: true
        }));
    }


    moveGalleryToMobile() {
        if (!this.$gallery.parent().hasClass('product-info-left')) {
            $('.rating-top').after(this.$gallery.detach());
        }
    }

    moveGalleryToDesktop() {
        if (!this.$gallery.parent().hasClass('primary_block')) {
            this.$gallery.detach().insertBefore($('.pb-options'));
        }
    }

    popop(){

        const $gallery = this.$gallery.find('#product_gallery');

        const $thumbs = this.$gallery.find('#product_gallery_thumbs');

        $(document).on('click tap', '#product_gallery .large img', e => {

            if (responsive.isHigherThan('sm')) {
                const $this = $(e.currentTarget);

                const items = [];
                let active = -1;

                $gallery.find('.large img').each((index, el) => {


                    items.push({
                        src: $(el).data('full'),
                        type: 'image'
                    });
                });

                var actives = parseInt(e.target.dataset.no);

                import(/* webpackChunkName: "magnific" */'./magnificPopup').then(() => {
                    $.magnificPopup.open({
                        items,
                        type: 'image',
                        tClose: '',
                        gallery: {
                            enabled: true
                        },
                        callbacks: {
                            open() {
                                $('.mfp-bg').addClass('white');
                                vars.lazyLoad.lazyLoadImges();
                            },
                            buildControls() {
                                try {
                                    this.contentContainer.append(this.arrowLeft.add(this.arrowRight));
                                }
                                catch (err) {
                                    // In case failed
                                }
                            }
                        }

                    }, actives);
                });


            }
        });
    }


    responsive() {
        $(window).on('kr.md.down', () => {
            this.moveGalleryToMobile();
        });

        $(window).on('kr.sm.down', () => {
            this.moveGalleryToMobile();
        });

        $(window).on('kr.xs.up', () => {
            this.moveGalleryToDesktop();
        });


    }


    events() {
        if (typeof minimalQuantity !== 'undefined' && minimalQuantity) {
            this.checkMinimalQuantity();
            $document.on('keyup', 'input[name=qty]', () => {
                this.checkMinimalQuantity(minimalQuantity);
            });
        }


        $document.on(change, '#quantity_wanted', e => {
            e.preventDefault();
            if (typeof productHasAttributes !== 'undefined' && productHasAttributes) {
                this.updateDisplay();
            }
            else {
                $('#our_price_display').text(tools.formatCurrency(parseFloat($('#our_price_display').attr('content')), currencyFormat, currencySign, currencyBlank));
            }
        });

        let updateTimeOut;
        $document.on('change.product', '#attributes input[type=hidden]', e => {
            e.preventDefault();
            clearTimeout(updateTimeOut);

            updateTimeOut = setTimeout(() => {
                const $this = $(e.currentTarget);
                const attribute = $this.val();
                const $fieldset = $this.closest('.attribute_fieldset');

                let $selected = null;
                $fieldset.find('.kli_attr').each((i, el) => {
                    const $kliAttr = $(el);

                    if ($("#perfumeBox-content").length != 0){
                        if (this.clickBoxDrop == false){
                            $kliAttr.toggleClass('selected', $kliAttr.data().attribute == attribute);
                        }else{
                            //  $('.attribute_listCapability-wrap .selected').click();
                        }
                    }else{
                        $kliAttr.toggleClass('selected', $kliAttr.data().attribute == attribute);
                    }

                    $selected = $kliAttr.data().attribute == attribute ? $kliAttr : $selected;
                });

                this.changeAvailableCombinations();

                if ($fieldset.hasClass('attribute_type_color')) {
                    $('.color-name .color').html($selected.data('color-name'));
                }

                if ($this.val()) {

                    var urlCombination = getUrlParameter('combination');
                    if (typeof urlCombination === "undefined") {
                        this.findCombination(true);
                    }else{
                        this.findCombination();

                        var event = new Event('change');
                        document.getElementById("idCombination").dispatchEvent(event);
                    }

                }
            }, 20);
        });


        var getUrlParameter = function getUrlParameter(sParam) {
            var sPageURL = window.location.search.substring(1),
                sURLVariables = sPageURL.split('&'),
                sParameterName,
                i;

            for (i = 0; i < sURLVariables.length; i++) {
                sParameterName = sURLVariables[i].split('=');

                if (sParameterName[0] === sParam) {
                    return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
                }
            }
        };


        $document.on(click, '.attribute_radio', e => {
            e.preventDefault();
            this.findCombination();
        });

        $document.on(click, 'button[name=saveCustomization]', () => {
            this.saveCustomization();
        });

        $document.on(click, '.cart-gift-add span', () => {
            $('.cart-gift-add-info').show();
        });


        $document.on(click, '.cart-gift-add-info .produnt-errors-popop-close', () => {
            $('.cart-gift-add-info .produnt-errors-popop').parent().hide();
        });
        $document.on(click, '.add-to-favs-error .produnt-errors-popop-close', () => {
            $('.add-to-favs-error .produnt-errors-popop').parent().hide();
        });

        if (typeof ad !== 'undefined' && ad && typeof adtoken !== 'undefined' && adtoken) {
            $document.on(click, 'a#publish_button', e => {
                e.preventDefault();
                this.submitPublishProduct(ad, 0, adtoken);
            });
            $document.on(click, 'a#lnk_view', e => {
                e.preventDefault();
                this.submitPublishProduct(ad, 1, adtoken);
            });
        }

        $('.quantity-up, .quantity-down').on(click, e => {
            this.changeQuantity($(e.currentTarget).hasClass('quantity-up') ? 1 : -1);
        });

        $('.atcfn-close').on(click, () => $('#newsletter-pop').addClass('hidden'));
        $document.on(click, '.arcfn-submit', e => this.submitStockSubscribtion(e));

        $('.rating-top .rateus').on(click, () => {
            import(/* webpackChunkName: "moduleLoader" */'../scripts/moduleLoader').then(({ default: moduleLoader }) => moduleLoader.loadModule('displayProductTabContent').then(() => {
                $('.reviews-wrapper').velocity('scroll', { duration: 700, offset: -80 });
            }));
        });

        $('.product-share-label').on('click', () => {
            import(/* webpackMode: "lazy", webpackChunkName: "share" */'./share').then(({ default: init }) => init().then(() => {
                $('.product-share-label').toggleClass('open');
                $('.product-share-content').toggle();
                $('.add-to-favs-error').hide();
            }));
        });

        $('.mobile-share').on('click', () => {
            $('.mobile-add-to-favs-error').hide();
            $('.mobile-share-url-block').hide();

            if (navigator.share) {

                navigator.share({
                    title: 'KlipShop',
                    url: window.location.href
                }).then(() => {
                    console.log('Thanks for sharing!');
                }).catch(console.error);

            }else{
                $('.mobile-add-to-favs-error').hide();
                $('.mobile-share-url-block .mobile-add-to-favs-error-text').html(window.location.href);
                $('.mobile-share-url-block').css('display','flex');
            }

        });

        $document.on(change, '#add_gift_box', e => {
            e.preventDefault();

            if ($('#add_gift_box').prop('checked')) {
                this.addGiftBox(giftBoxProductId, giftBoxProductAtrId);
            }else{
                this.removeGiftBox(giftBoxProductId, giftBoxProductAtrId);
            }



        });

    }

    addGiftBox(idProduct, idCombination, quantity = 1){

        $.ajax({
            type: 'POST',
            headers: {
                'cache-control': 'no-cache'
            },
            url: `${baseUri}?rand=${new Date().getTime()}`,
            async: true,
            cache: false,
            dataType: 'json',
            data: `controller=cart&add=1&addfromcart=true&ajax=true&qty=${(quantity && quantity != null) ? quantity : '1'}&id_product=${idProduct}&token=${static_token}${(parseInt(idCombination, 10) && idCombination != null) ? `&ipa=${parseInt(idCombination, 10)}` : `&id_customization=${(typeof customizationId !== 'undefined') ? customizationId : 0}`}`,

            success(jsonData) {
                if (!jsonData.hasError) {
                    $('.ajax_cart_quantity').text(jsonData.nbTotalProducts);
                }

            }

        });
    }

    removeGiftBox(productId, productAttributeId){

        var url = baseUri + '?rand=' + new Date().getTime();
        var customizationId = 0;

        var datax = 'controller=cart'
            + '&ajax=true&delete=true&summary=true'
            + '&id_product=' + productId
            + '&ipa=' + productAttributeId
            + ((customizationId !== 0) ? '&id_customization=' + customizationId : '')
            + '&token=' + static_token
            + '&allow_refresh=1';

        $.ajax({
            type: 'POST',
            headers: {"cache-control": "no-cache"},
            url: url,
            async: true,
            cache: false,
            dataType: 'json',
            context: this,
            data: datax,
            success: function (jsonData) {
                if (!jsonData.hasError) {
                    $('.ajax_cart_quantity').text(jsonData.nbTotalProducts);
                }
            }
        });

    }



    documentReady() {
        this.$options = $('.pb-options');
        this.$primaryBlock = $('.primary_block');
        this.$masterslider = $('#masterslider');
        this.$colorToPick = $('#color_to_pick_list');
        this.$centerColumn = $('#center_column');
        this.clickBoxDrop = false;
        // $('.rating').rating();
        $('.current-img').removeClass('current-img-next');

        $('#buy_block').on(click, 'button:not([type=submit])', e => {
            e.preventDefault();rating-top
        });

        this.responsive();

        this.collapsables();

        const urlFound = this.checkUrl();
        if (!urlFound) {
            if (typeof productHasAttributes !== 'undefined' && productHasAttributes) {
                this.findCombination(true);
            }
            else if (typeof (this.selectedCombination.unavailable) === 'undefined' && quantityAvailable === 0) {
                const $buttonas = $('#add_to_cart');
                const $buttonasspan = $('#add_to_cart span');
                $buttonas.addClass('out-of-stock');
                $buttonasspan.text($buttonasspan.data('notify'));
                $('.add-to-cart-false-newsletter').addClass('hidden');
                $('[name=atcfn-product]').val($('#product_page_product_id').val());
                $('[name=atcfn-attribute]').val();

            }
        }


        $(document).on("select2:select","#perfumeBox",  e =>{

            e.preventDefault();

            const attribute = e.params.data.id;
            const $this = $(e.currentTarget);
            const $groupInput = $('.attribute_fieldset').find('input[type=hidden]');
            this.clickBoxDrop = true;

            $groupInput
                .trigger('change.product');

            this.updateGallery();

            if ($('.attribute_hidden').val() || $('.color_pick_hidden').val()) {
                this.findCombination();
            }

        });


        $document.on(click, '.kli_attr', e => {
            e.preventDefault();

            if ($('.attribute_hidden').val() || $('.color_pick_hidden').val()) {
                this.findCombination();
            }


            const $this = $(e.currentTarget);
            const attribute = $this.data().attribute;
            this.clickBoxDrop = false;
            const $groupInput = $this.closest('.attribute_fieldset').find('input[type=hidden]');

            if ($("#perfumeBox-content").length != 0){
                this.updatePerfumeBox(attribute);
            }

            $groupInput
                .val(attribute)
                .trigger('change.product');
            this.updateGallery();


        });


        $('.kli_attr.selected').each((i, el) => {
            const $this = $(el);
            const attribute = $this.data().attribute;
            const $groupInput = $this.closest('.attribute_fieldset').find('input[type=hidden]');
            $groupInput
                .val(attribute)
                .trigger('change.product');
        });

        $('.close-iksas, body').on(click, () => {
            $('.addtocarterrorwrapper').velocity('fadeOut', 200);
        });


        import(/* webpackChunkName: "ajaxCart" */'./ajaxCart');
        import(/* webpackChunkName: "favourites" */'../scripts/favourites').then(({ default: initFavourites }) => {
            initFavourites();
        });
        import(/* webpackChunkName: "terms" */'./terms').then(({ default: initTerms }) => {
            initTerms();
        });
    }

    updatePerfumeBox(e){
        let attrBoxId = e;


        let attrBoxIdArray = dropDownAttributeCombinations[attrBoxId];
        var boxOption = '';
        var haveDef = false;

        for(var ibx1 = 0; ibx1 < Object.keys(dropDownCombination).length; ibx1++) {
            var exsistCombinationBox1 = false;

            if(this.ifExsistCombinationParfum(attrBoxId,dropDownCombination[ibx1].key)){
                var exsistCombinationBox1 = true;
            }


            if(dropDownCombination[ibx1].attributes_quantity > 0 && exsistCombinationBox1 == true ){
                var haveDef = true;
            }

        }  //pasitikrinome ar bus def atributas

        var tempArrPack = [];
        var boxOptionSelectIsSetSelect = false;



        for(var ibx = 0; ibx < Object.keys(dropDownCombination).length; ibx++) {
            var boxOptionSelect = '';
            var ifBoxExist = '';
            var ifBoxDisabled = '';
            var exsistCombinationBox = false;

            if(this.ifExsistCombinationParfum(attrBoxId,dropDownCombination[ibx].key)){
                var exsistCombinationBox = true;
            }

            if(parseInt(dropDownCombination[ibx].attributes_quantity) < 1 || exsistCombinationBox == false ){
                var ifBoxExist = 'Šiuo metu neturime';
                var ifBoxDisabled = 'disabled';
            }else{
                if(boxOptionSelectIsSetSelect == false){
                    var boxOptionSelect = 'selected';
                }

                var boxOptionSelectIsSetSelect = true;
            }

            if(haveDef == false && ibx == 0){
                var ifBoxDisabled = '';
                if(boxOptionSelectIsSetSelect == false){
                    var boxOptionSelect = 'selected';
                }
                var boxOptionSelectIsSetSelect = true;
            }


            boxOption += "<option "+ifBoxDisabled+" "+boxOptionSelect+" data-info='"+ifBoxExist+"' value="+dropDownCombination[ibx].key+">"+dropDownCombination[ibx].attributes+"</option>";


        }

        let htmlIn = "<select id='perfumeBox'>";
        htmlIn += boxOption;
        htmlIn += "</select>";

        $('#perfumeBox-content').html(htmlIn);

        $("#perfumeBox").select2({
            templateResult: perfumeBoxSelect2,
            templateSelection: perfumeBoxSelectDefault2,
            minimumResultsForSearch: 22,
            width: '100%',
        });

    }


    ifExsistCombinationParfum(capacityId, boxId){

        for (var val in dropDownAttributeCombinations) {

            let arrs = dropDownAttributeCombinations[val].attributes;
            if (arrs.includes(parseInt(capacityId)) && arrs.includes(parseInt(boxId)) && dropDownAttributeCombinations[val].quantity > 0){
                return true;
            }
        }

        return false;
    }

    setAttributePrices() {
        if (typeof this.currentCombination !== 'undefined' && typeof this.currentCombination.idsAttributes !== 'undefined') {
            const priceNew = `${parseFloat(this.priceWithDiscountsDisplay).toFixed(2)} ${currencySign}`;
            const priceOld = `${parseFloat(this.basePriceDisplay).toFixed(2)} ${currencySign}`;

            for (const id_attribute of this.currentCombination.idsAttributes) {
                const $attribute = $(`[data-attribute='${id_attribute}']:not([data-color-name])`);

                if ($attribute.length) {
                    const $priceNew = $attribute.find('.kaina-attributo-r');
                    let $priceOld = $attribute.find('.kaina-attributo-s');

                    if (!$priceOld.length) {
                        $priceOld = $('<span class="kaina-attributo-s"></span>');
                        $priceNew.after($priceOld);
                    }

                    $priceNew.html(priceNew);

                    if (this.priceWithDiscountsDisplay == this.basePriceDisplay) {
                        $priceOld.html('');
                    }
                    else {
                        $priceOld.html(priceOld);
                    }
                }
            }
        }
    }

    changePriceAtr(obj) {
        $(obj).each((key, val) => {
            if (val.priceNew !== val.priceOld) {
                $(`.attribute_listCapability .id_${val.atributeId} .kainaAtributo .kaina-attributo-inner .kaina-attributo-r`).html(`${parseFloat(val.priceNew).toFixed(2)} ${currencySign}`);

                if ($(`.attribute_listCapability .id_${val.atributeId} .kainaAtributo .kaina-attributo-inner .kaina-attributo-s`).length) {
                    $(`.attribute_listCapability .id_${val.atributeId} .kainaAtributo .kaina-attributo-inner .kaina-attributo-s`).html(`${parseFloat(val.priceOld).toFixed(2)} ${currencySign}`);
                }
                else {
                    $(`.attribute_listCapability .id_${val.atributeId} .kainaAtributo .kaina-attributo-inner`).append(`<div class="span kaina-attributo-s">${parseFloat(val.priceOld).toFixed(2)} ${currencySign}</div>`);
                }
            }
            else {
                $(`.attribute_listCapability .id_${val.atributeId} .kainaAtributo .kaina-attributo-inner .kaina-attributo-r`).html(`${parseFloat(val.priceNew).toFixed(2)} ${currencySign}`);
                $(`.attribute_listCapability .id_${val.atributeId} .kainaAtributo .kaina-attributo-inner .kaina-attributo-s`).html('');
            }
        });
    }


    changeAvailableCombinations() {
        let selectedAttributeCombinations = [];
        let choice = [];

        if ($("#perfumeBox-content").length != 0){
            const kintamasis = $("#perfumeBox").val();
            choice.push(kintamasis);
            selectedAttributeCombinations = selectedAttributeCombinations.concat(attributeCombinations[kintamasis]);
        }

        $('#attributes .attribute_hidden, #attributes .color_pick_hidden').each((i, el) => {
            const kintamasis = $(el).val();
            choice.push(kintamasis);
            selectedAttributeCombinations = selectedAttributeCombinations.concat(attributeCombinations[kintamasis]);
        });

        choice = choice.sort();
        $('#attributes .kli_attr').each((i, el) => {
            const $this = $(el);
            const id_attribute = $this.data('attribute');
            // Ijungiam/isjungiam pagal kiekius
            for (const id_choice of choice) {
                if ((choice.length >= 1 && id_choice !== id_attribute) || choice.length === 1) {
                    let combinationKey = [id_attribute];
                    if (choice.length > 1) {
                        combinationKey.push(id_choice);
                    }
                    combinationKey = [...new Set(combinationKey.map(id => parseInt(id, 10)))].sort().join('-');

                    const combination = this.combinationsHashSet[combinationKey];
                    if (typeof combination !== 'undefined' && $("#perfumeBox-content").length == 0) {
                        $this.toggleClass('noQty', parseInt(combination.quantity, 10) <= 0);
                        if(parseInt(combination.quantity, 10) <= 0) {
                            $this.attr('data-stock', 0);

                        } else {
                            $this.attr('data-stock', 2);
                            if (!allowBuyWhenOutOfStock) {
                                if (parseInt(combination.quantity, 10) <= maxQuantityToAllowDisplayOfLastQuantityMessage) {
                                    $this.attr('data-stock', 1);
                                }
                            }

                        }


                    }
                }
            }
            if (choice.length > 1) {

                if ($("#perfumeBox-content").length == 0){
                    $this.toggleClass('disableAtr', selectedAttributeCombinations.indexOf(String(id_attribute)) == -1);
                }

            }
        });


        if (choice.length > 1) {
            let combainationValid = true;
            const combination = attributeCombinations[choice[0]];
            for (const choice_id_attribute of choice) {
                if (!combination.some(combination_id_attribute => parseInt(combination_id_attribute, 10) === parseInt(choice_id_attribute, 10))) {
                    combainationValid = false;
                    break;
                }
            }

            if (!combainationValid) {
                for (const id_attribute of choice) {
                    if ($("#perfumeBox-content").length == 0){
                        $(`.kli_attr[data-attribute='${id_attribute}']`).addClass('disableAtr');
                    }
                }
            }

            $buyBlock.toggleClass('invalid-combination', !combainationValid);
            $('.stickyBlock-left').toggleClass('invalid-combination', !combainationValid);
        }

        const combinationData = this.combinationsHashSet[choice.sort().join('-')];
        if (typeof combinationData !== 'undefined') {
            $buyBlock.toggleClass('invalid-combination', combinationData.quantity <= 0);
            $('.stickyBlock-left').toggleClass('invalid-combination', combinationData.quantity <= 0);
        }


        this.updateColorSelect();
        return [...new Set(selectedAttributeCombinations)];
    }

    arrayUnique(a) {
        return a.reduce((p, c) => {
            if (p.indexOf(c) < 0) {
                p.push(c);
            }
            return p;
        }, []);
    }

    functionExists(functionName) {
        let r;
        if (typeof functionName === 'string') {
            r = this.window[functionName];
        }
        return typeof r === 'function';
    }

    oosHookJsCode() {
        for (let i = 0; i < oosHookJsCodeFunctions.length; i++) {
            if (this.functionExists(oosHookJsCodeFunctions[i])) {
                setTimeout(window[oosHookJsCodeFunctions[i]], 0);
            }
        }
    }

    addCombination(idCombination, arrayOfIdAttributes, quantity, price, ecotax, idImage, reference, unitPrice, minimalQuantity, availableDate, combinationSpecificPrice) {
        this.globalQuantity += quantity;

        const combination = [];
        combination.idCombination = idCombination;
        combination.quantity = quantity;
        combination.idsAttributes = arrayOfIdAttributes;
        combination.price = price;
        combination.ecotax = ecotax;
        combination.image = idImage;
        combination.reference = reference;
        combination.unit_price = unitPrice;
        combination.minimal_quantity = minimalQuantity;
        combination.available_date = [];
        combination.available_date = availableDate;
        combination.specific_price = [];
        combination.specific_price = combinationSpecificPrice;
        combinations.push(combination);
    }

    findCombination(fromDocumentReady = false) {

        $('#quantity_wanted_p .quantity_wanted-wrap .quantity-down').addClass('quantity-down-non-active');

        if (typeof productHasAttributes !== 'undefined' && productHasAttributes) {
            if (typeof $('#minimal_quantity_label').text() === 'undefined' || $('#minimal_quantity_label').html() > 1) {
                $('#quantity_wanted').val(1);
            }

            const choice = [];
            let radioInputs = parseInt($('#attributes .checked > input[type=radio]').length, 10);
            if (radioInputs) {
                radioInputs = '#attributes .checked > input[type=radio]';
            }
            else {
                radioInputs = '#attributes input[type=radio]:checked';
            }

            $(`#attributes input[type=hidden], ${radioInputs}`).each((i, el) => {
                const id_attribute = parseInt($(el).val(), 10);
                if (id_attribute !== 0) {
                    choice.push(id_attribute);
                }
            });

            if ($("#perfumeBox-content").length != 0){
                choice.push($("#perfumeBox").val());
            }



            if (typeof this.combinationsHashSet !== 'undefined') {
                const combination = this.combinationsHashSet[choice.sort().join('-')];
                if (combination) {
                    if (combination.minimal_quantity > 1) {
                        $('#minimal_quantity_label').html(combination.minimal_quantity);
                        $('#minimal_quantity_wanted_p').fadeIn();
                        $('#quantity_wanted').val(combination.minimal_quantity);
                        $('#quantity_wanted').bind('keyup', () => {
                            this.checkMinimalQuantity(combination.minimal_quantity);
                        });
                    }
                    this.selectedCombination.unavailable = false;
                    this.selectedCombination.reference = combination.reference;
                    $('#idCombination').val(combination.idCombination);

                    quantityAvailable = combination.quantity;
                    this.selectedCombination.quantity = combination.quantity;
                    this.selectedCombination.price = combination.price;
                    this.selectedCombination.unit_price = combination.unit_price;
                    this.selectedCombination.specific_price = combination.specific_price;
                    this.selectedCombination.description = combination.description;
                    if (combination.ecotax) {
                        this.selectedCombination.ecotax = combination.ecotax;
                    }
                    else {
                        this.selectedCombination.ecotax = default_eco_tax;
                    }

                    if (combination.idCombination && combination.idCombination > 0) {

                        const combnr = combination.idCombination;
                        const combattr = this.combinationsOriginal[combnr].attributes_values;
                        let combname = '';
                        let combnf = '';
                        if (combattr) {
                            Object.keys(combattr).forEach(key => {

                                combname += `${combattr[key]} `;

                            });

                            combnf = combname.slice(0, -1);
                        }

                        $('#galune').val(combnf);
                    }

                    this.selectedCombination.available_date = combination.available_date;
                    this.currentCombination = combination;

                    try {
                        let price = this.currentCombination.price;
                        let stock_label='';
                        if (this.currentCombination.specific_price.reduction_percent > 0) {
                            price = this.currentCombination.price - ((this.currentCombination.price * this.currentCombination.specific_price.reduction_percent) / 100);
                            price = parseFloat(price).toFixed(2);
                        }
                        if(this.selectedCombination.quantity>0) {
                            stock_label='In Stock';
                        } else {
                            stock_label='Out of stock';
                        }
                        if(typeof tagInfo !== 'undefined') {
                            const data = {
                                dimension1: tagInfo.dimension1,
                                dimension2: this.currentCombination.idCombination.toString(),
                                dimension3: tagInfo.dimension3,
                                dimension4: price,
                                dimension5: stock_label,
                            };
                        }
                    }
                    catch (e) {
                        console.warn(`GTAG SHOPPING FAILED`, e);
                    }

                    if(fromDocumentReady == false){
                        history.replaceState({ idCombination: combination.idCombination }, null, `?combination=${combination.idCombination}`);
                    }

                    this.updateDisplay();

                    if (this.firstTime) {
                        this.firstTime = false;
                    }
                    return;
                }
                // COMBINATION OF ATTRIBUTES DOES NOT EXIST

            }

            this.currentCombination = undefined;
            this.selectedCombination.unavailable = true;
            if (typeof (this.selectedCombination.available_date) !== 'undefined') {
                delete this.selectedCombination.available_date;
            }
            this.updateDisplay();


        }
    }

    checkIgnore() {
        if (typeof combinations !== 'undefined') {
            return combinations.length <= 1;
        }
        return true;
    }

    postGAnalytics(object) {
        if (this.postedToAnalytics || this.checkIgnore()) {
            let noInteraction = {};
            if (window.MBG !==undefined) {
                try {
                    window.MBG.addProductDetailView(cat_template_name);
                } catch (e) {
                    console.warn("Unable to set gtag");
                }

            }


            if(this.manualChange === false) {
                noInteraction = {
                    nonInteraction: true
                }
            }
            this.manualChange = true;
        }
        this.postedToAnalytics = !this.postedToAnalytics;
    }

    updateQuantityWanted() {

    }

    updateAttributeDescription() {
        const $attributeDescription = $('.page-product-combination-about');
        if (typeof this.selectedCombination.description === 'undefined' || !this.selectedCombination.description) {
            $attributeDescription.hide();
        }
        else {
            $attributeDescription.show().find('.rte').html(this.selectedCombination.description);
        }
    }

    updateDisplay() {
        // console.trace('test');
        this.updateAttributeDescription();
        this.updateQuantityWanted();
        let $buttonas;
        let $buttonasspan;
        const $quantityElement = $('#quantity_wanted');
        const $addToCart = $('#add_to_cart span');
        const $addToCartBtn = $addToCart.parents('button');
        $addToCartBtn.removeClass('disabled');


        try {
            $quantityElement.attr('max', this.currentCombination.quantity ? this.currentCombination.quantity : 0);
            if (this.currentCombination.quantity >= 1) {
                $quantityElement.val('1');
            }
            else {
                $quantityElement.val('0');
            }
        }
        catch (err) {
            $quantityElement.val('1');
        }

        // const productPriceDisplay = productPrice;
        // const productPriceWithoutReductionDisplay = productPriceWithoutReduction;
        if (this.selectedCombination.unavailable) {
            $('#add_to_cart').addClass('disableAddToCard');
        }
        else {
            $('#add_to_cart').removeClass('disableAddToCard');
        }


        if(this.currentCombination=== undefined){
            return;
        }

        // jei kaina 0 isjungiam add to cart
        if(this.currentCombination.price <= 0){
            $('#add_to_cart').addClass('hidden');
            $('#favorite-wrap').hide();
        }else{
            $('#add_to_cart').removeClass('hidden');
            $('#favorite-wrap').show();
        }

        if (!this.selectedCombination.unavailable && quantityAvailable > 0 && productAvailableForOrder) {

            // hide the hook out of stock
            $('#oosHook').hide();

            $('#availability_date').fadeOut();

            // availability value management
            const $qtyWanted = $('#quantity_wanted_p');
            const $outOfStock = $('#out-of-stock-line');
            const $productRef = $('.product-reference-wrap');
            if (stock_management && availableNowValue !== '') {
                $qtyWanted.addClass('pliusas');
                $buyBlock.addClass('invalid-combination');
                $('.stickyBlock-left').addClass('invalid-combination');

                $outOfStock.removeClass('hidden');
                $addToCart.html(() => {
                    $(this).parent().addClass('disabled');
                    return $(this).data('out-of-stock');
                });

            }
            else {
                $outOfStock.addClass('hidden');
                $buyBlock.removeClass('invalid-combination');
                $('.stickyBlock-left').removeClass('invalid-combination');
                $addToCart.html(() => {
                    $(this).parent().removeClass('disabled');
                    return $(this).data('add-to-cart');
                });
            }

            // 'last quantities' message management
            const $lastQtys = $('#last_quantities');
            if (!allowBuyWhenOutOfStock) {
                if (quantityAvailable <= maxQuantityToAllowDisplayOfLastQuantityMessage) {
                    $lastQtys.show();

                }
                else {
                    $lastQtys.hide();
                }

            }

            const $textAvailable = $('#quantityAvailableTxt');
            const $textAvailableMultiple = $('#quantityAvailableTxtMultiple');
            if (quantitiesDisplayAllowed) {
                $('#pQuantityAvailable:hidden').show();
                $('#quantityAvailable').text(quantityAvailable);

                if (quantityAvailable < 2) {
                    $textAvailable.show();
                    $textAvailableMultiple.hide();
                }
                else {
                    $textAvailable.hide();
                    $textAvailableMultiple.show();
                }

            }


            $buttonas = $('#add_to_cart');
            $buttonasspan = $('#add_to_cart span');
            $buttonas.removeClass('out-of-stock');
            $buttonasspan.text($buttonasspan.data('add-to-cart'));
            $('.add-to-cart-false-newsletter').addClass('hidden');

        }
        else {
            // show the hook out of stock
            if (productAvailableForOrder === 1) {
                $('#oosHook').show();
                if ($('#oosHook').length > 0) {
                    this.oosHookJsCode();
                }
            }

            // hide 'last quantities' message if it was previously visible
            $('#last_quantities:visible').hide(0);

            // hide the quantity of pieces if it was previously visible
            $('#pQuantityAvailable:visible').hide(0);

            // hide the choice of quantities
            //   if (!allowBuyWhenOutOfStock)
            //       $('#quantity_wanted_p:visible').hide('slow');

            // display that the product is unavailable with theses attributes
            if (!this.selectedCombination.unavailable) {
                $buyBlock.addClass('invalid-combination');
                $('.stickyBlock-left').addClass('invalid-combination');
                $('#out-of-stock-line').removeClass('hidden');
                $('#availability_value').text(doesntExistNoMore + (this.globalQuantity > 0 ? ` ${doesntExistNoMoreBut}` : ''));
                if (!allowBuyWhenOutOfStock) {
                    $('#availability_value').removeClass('label-success').addClass('label-warning');
                }

                $addToCart.html(() => {
                    $addToCart.parent().addClass('disabled');
                    return $addToCart.data('out-of-stock');
                });
            }
            else {
                $buyBlock.removeClass('invalid-combination');
                $('.stickyBlock-left').removeClass('invalid-combination');
                $('#out-of-stock-line').addClass('hidden');
                $('#availability_value').text(doesntExist).removeClass('label-success').addClass('label-warning');
                $('#oosHook').hide();

                $addToCart.html(() => {
                    $addToCart.parent().removeClass('disabled');
                    return $addToCart.data('add-to-cart');
                });
            }

            if ((stock_management === 1 && !allowBuyWhenOutOfStock) || (!stock_management && this.selectedCombination.unavailable)) {
                $('#out-of-stock-line').removeClass('hidden');
                $buyBlock.addClass('invalid-combination');
                $('.stickyBlock-left').addClass('invalid-combination');

                $addToCart.html(() => {
                    $addToCart.parent().addClass('disabled');
                    return $addToCart.data('out-of-stock');
                });
            }

            if (typeof (this.selectedCombination.available_date) !== 'undefined' && typeof (this.selectedCombination.available_date.date_formatted) !== 'undefined' && this.selectedCombination.available_date.date.length !== 0) {
                const availableDate = this.selectedCombination.available_date.date;
                const tabDate = availableDate.split('-');
                const timeAvailable = new Date(tabDate[0], tabDate[1], tabDate[2]);
                timeAvailable.setMonth(timeAvailable.getMonth() - 1);
                const now = new Date();
                if (now.getTime() < timeAvailable.getTime() && $('#availability_date_value').text() !== this.selectedCombination.available_date.date_formatted) {
                    const $availabilityDate = $('#availability_date');
                    $availabilityDate.fadeOut('normal', () => {
                        $('#availability_date_value').text(this.selectedCombination.available_date.date_formatted);
                        $availabilityDate.fadeIn();
                    });
                }
                else if (now.getTime() < timeAvailable.getTime()) {
                    $('#availability_date').fadeIn();
                }
            }
            else {
                $('#availability_date').fadeOut();
            }

            // show the 'add to cart' button ONLY IF it's possible to buy when out of stock AND if it was previously invisible
            if (allowBuyWhenOutOfStock && !this.selectedCombination.unavailable && productAvailableForOrder) {
                // $('#add_to_cart:hidden').fadeIn(600);

                if (stock_management && availableLaterValue !== '') {
                    $buyBlock.addClass('invalid-combination');
                    $('.stickyBlock-left').addClass('invalid-combination');
                    $('#out-of-stock-line').removeClass('hidden');
                    $addToCart.html(() => {
                        $addToCart.parent().addClass('disabled');
                        return $addToCart.data('out-of-stock');
                    });
                }
                else {
                    $buyBlock.removeClass('invalid-combination');
                    $('.stickyBlock-left').removeClass('invalid-combination');
                    $('#out-of-stock-line').addClass('hidden');
                    $addToCart.html(() => {
                        $addToCart.parent().removeClass('disabled');
                        return $addToCart.data('add-to-cart');
                    });
                }
            }
            else if (stock_management === 1 && productAvailableForOrder) {
                $buyBlock.addClass('invalid-combination');
                $('.stickyBlock-left').addClass('invalid-combination');
                $('#out-of-stock-line').removeClass('hidden');
                $addToCart.html(() => {
                    $addToCart.parent().addClass('disabled');
                    return $addToCart.data('out-of-stock');
                });
            }


            if (productAvailableForOrder === 0) {
                $buyBlock.removeClass('invalid-combination');
                $('.stickyBlock-left').addClass('invalid-combination');
                $('#out-of-stock-line').addClass('hidden');
                $addToCart.html(() => $addToCart.data('add-to-cart'));
            }

            $buttonas = $('#add_to_cart');
            $buttonasspan = $('#add_to_cart span');
            $buttonas.addClass('out-of-stock');
            $buttonasspan.text($buttonasspan.data('notify'));
            if (productAvailableForOrder === false) {
                $('#out-of-stock-line').addClass('hidden');
                $addToCart.html(() => {
                    $addToCart.parent().parent().removeClass('out-of-stock');
                    $addToCart.parent().parent().addClass('not-available-for-order');
                    $addToCart.parent().parent().addClass('disabled');
                    $addToCart.parent().parent().addClass('disableAddToCard');
                    return $addToCart.data('not-available-for-order');
                });

            }

            $('.add-to-cart-false-newsletter').addClass('hidden');
            $('[name=atcfn-product]').val($('#product_page_product_id').val());
            try {
                $('[name=atcfn-attribute]').val(this.currentCombination.idCombination);
            }
            catch (err) {
                // err
            }
        }

        if (this.selectedCombination.reference || productReference) {
            if (this.selectedCombination.reference) {
                $('#product_reference span').text(this.selectedCombination.reference);
            }
            else if (productReference) {
                $('#product_reference span').text(productReference);
            }
            $('#product_reference:hidden').show('slow');
        }
        else {
            $('#product_reference:visible').hide('slow');
        }

        if (productHasAttributes) {
            this.updatePrice();
        }

        this.postGAnalytics();
    }


    updateGallery(){

        const choice = [];
        let radioInputs = parseInt($('#attributes .checked > input[type=radio]').length, 10);
        if (radioInputs) {
            radioInputs = '#attributes .checked > input[type=radio]';
        }
        else {
            radioInputs = '#attributes input[type=radio]:checked';
        }

        $(`#attributes input[type=hidden], ${radioInputs}`).each((i, el) => {
            const id_attribute = parseInt($(el).val(), 10);
            if (id_attribute !== 0) {
                choice.push(id_attribute);
            }
        });

        if ($("#perfumeBox-content").length != 0){
            choice.push($("#perfumeBox").val());
        }

        var combination = this.combinationsHashSet[choice.sort().join('-')];


        if (combination === undefined){
            return;
        }

        var combinationId = combination.idCombination;



        var galleryOjb = JSON.parse(galleryCombination);

        var prod_mini = galleryOjb[combinationId]['prod_mini'];
        var prod_large = galleryOjb[combinationId]['prod_large'];
        var prod_full = galleryOjb[combinationId]['prod_full'];
        var i_mini;


        var cutentImg = '';
        var returnMiniProduct = '';
        var returnDots = '';
        var returnList = '';
        for (i_mini = 0; i_mini < prod_mini.length; i_mini++) {

            var init = '';
            var initDots = '';
            if(i_mini == 0){
                var cutentImg = prod_large[i_mini];
                var init = 'init';
                var initDots = 'dots-active';
            }

            var displayNone = '';
            if(prod_mini.length < 2){
                var displayNone = "style='display:none;'";
            }

            var i_mini_2 = i_mini+1;

            returnMiniProduct += '<div data-thumno="'+i_mini+'" class="product-gallery product-image-thumb thumb-no_'+i_mini+' thumb '+init+'" data-src="'+prod_large[i_mini]+'"> <img src="'+prod_mini[i_mini]+'" alt=""></div>';

            returnDots += '<div '+displayNone+' data-dotsno="'+i_mini_2+'" class="dots-item-no_'+i_mini_2+' dots-item '+initDots+'" data-src="'+prod_large[i_mini]+'"></div>';


            returnList += '<img data-no="'+i_mini+'" id="current-img" class="current-img" data-large="'+prod_large[i_mini]+'" src="'+prod_large[i_mini]+'" data-full="'+prod_full[i_mini]+'">';

        }

        var size = (myImg*prod_mini.length)+10;
        maxImages = prod_mini.length;
        currentImg = 0;
        if(document.body.clientWidth < 993){
            $('.product-gallery-img-content').css('width',size+'px');
            $('.product-gallery-img-content').css('transition-duration','0s');
            $('.product-gallery-img-content').css('transform','translate(0px)');
        }

        $('.product-gallery-content').attr('data-noblock',1);

        $('.current-img').attr('src',cutentImg);
        $('.current-img').attr('data-large',cutentImg);
        $('.current-img').attr('data-no','0');

        $('.product-gallery-img-content').html(returnList);
        $('#product_gallery_thumbs').html(returnMiniProduct);
        $('.product-gallery-dots').html(returnDots);
        this.imageChange();
    }


    imageChange(){

        $('.product-image-thumb').on('click', (e) => {
            $('.current-img').attr('src',e.currentTarget.dataset.src);
            $('.current-img').attr('data-large',e.currentTarget.dataset.src);
            $('.product-image-thumb').removeClass('init');

            var clickNo = e.currentTarget.dataset.thumno;

            $('.current-img').attr('data-no',clickNo);

            $('.thumb-no_'+clickNo).addClass('init');
            $('.dots-item').removeClass('dots-active');
            $('.dots-item-no_'+clickNo).addClass('dots-active');
        });


        $('.dots-item').on('click', (e) => {

            $('.dots-item').removeClass('dots-active');
            var clickNo = e.currentTarget.dataset.dotsno;
            $('.dots-item-no_'+clickNo).addClass('dots-active');
            $('.product-gallery-content').attr('data-noblock',clickNo);

            currentImg = clickNo-1;

            scrollImages((IMG_WIDTH * clickNo)-myImg, 100);
            $('body').css('overflow','auto');
        });

        if(document.body.clientWidth < 768 && maxImages > 1){
            var swipeOptions = {
                triggerOnTouchEnd: true,
                swipeStatus: this.swipeStatus,
                allowPageScroll: "vertical",
                threshold: 75
            };

            $('.product-gallery').swipe(swipeOptions);
        }

    }

    swipeStatus(event, phase, direction, distance) {

        //If we are moving before swipe, and we are going L or R in X mode, or U or D in Y mode then drag.
        if (phase == "move" && (direction == "left" || direction == "right")) {
            var duration = 0;


            if (direction == "left") {
                scrollImages((IMG_WIDTH * currentImg) + distance, duration);
            } else if (direction == "right") {
                scrollImages((IMG_WIDTH * currentImg) - distance, duration);

            }

        } else if (phase == "cancel") {
            scrollImages(IMG_WIDTH * currentImg, speed);
            $('body').css('overflow','auto')
        } else if (phase == "end") {
            if (direction == "right") {
                previousImage();
            } else if (direction == "left") {
                nextImage();
            }

            swipeHandler(event, direction);
            $('body').css('overflow','auto')
        }

    }



    updatePrice() {
        const $elementS = $('.kli_attr.selected');
        if (typeof $elementS.attr('data-productname') !== 'undefined' || this.currentCombination.idsAttributes.length>1) {
            let newname;
            const $element = $('.product-info-left h1 span');

            try {
                newname = `${baseName} ${Object.values(this.combinationsOriginal[this.currentCombination.idCombination].attributes_values).join(', ')}`;
            }
            catch (err) {
                newname = baseName;
            }

            $element.html(newname);
        }
        const combID = $('#idCombination').val();
        const combination = this.combinationsOriginal[combID];
        let discountValue;
        let discountPercentage;
        if (typeof combination === 'undefined') {
            return;
        }

        let basePriceWithoutTax = +productPriceTaxExcluded;
        let basePriceWithTax = +productPriceTaxIncluded;
        let priceWithGroupReductionWithoutTax = 0;

        priceWithGroupReductionWithoutTax = basePriceWithoutTax * (1 - groupReduction);

        basePriceWithoutTax += +combination.price;
        basePriceWithTax += +combination.price * ((taxRate / 100) + 1);


        let priceWithDiscountsWithoutTax = basePriceWithoutTax;
        let priceWithDiscountsWithTax = basePriceWithTax;

        if (default_eco_tax) {
            // combination.ecotax doesn't modify the price but only the display
            priceWithDiscountsWithoutTax += default_eco_tax * (1 + (ecotaxTax_rate / 100));
            priceWithDiscountsWithTax += default_eco_tax * (1 + (ecotaxTax_rate / 100));
            basePriceWithTax += default_eco_tax * (1 + (ecotaxTax_rate / 100));
            basePriceWithoutTax += default_eco_tax * (1 + (ecotaxTax_rate / 100));
        }

        if (combination.specific_price && combination.specific_price.reduction > 0) {
            if (combination.specific_price.reduction_type === 'amount') {
                if (typeof combination.specific_price.reduction_tax !== 'undefined' && combination.specific_price.reduction_tax === '0') {
                    let reduction = combination.specific_price.reduction;
                    if (combination.specific_price.id_currency === 0) {
                        reduction = reduction * currencyRate * (1 - groupReduction);
                    }
                    priceWithDiscountsWithoutTax -= reduction;
                    priceWithDiscountsWithTax -= reduction * ((taxRate / 100) + 1);
                }
            }
            else if (combination.specific_price.reduction_type === 'percentage') {
                priceWithDiscountsWithoutTax *= (1 - +combination.specific_price.reduction);
                priceWithDiscountsWithTax *= (1 - +combination.specific_price.reduction);
            }
        }

        if (noTaxForThisProduct || customerGroupWithoutTax) {
            this.basePriceDisplay = basePriceWithoutTax;
            this.priceWithDiscountsDisplay = priceWithDiscountsWithoutTax;
        }
        else {
            this.basePriceDisplay = basePriceWithTax;
            this.priceWithDiscountsDisplay = priceWithDiscountsWithTax;
        }

//        if (id_shop === 5 && this.priceWithDiscountsDisplay >= 15 && this.priceWithDiscountsDisplay <= 17) {
//            this.priceWithDiscountsDisplay = 14.94;
//        }



        if (combination.specific_price && combination.specific_price.reduction > 0) {

            if (combination.specific_price.reduction_type === 'amount') {
                if (typeof combination.specific_price.reduction_tax === 'undefined' || (typeof combination.specific_price.reduction_tax !== 'undefined' && combination.specific_price.reduction_tax === '1')) {
                    let reduction = combination.specific_price.reduction;

                    if (typeof specific_currency !== 'undefined' && specific_currency && parseInt(combination.specific_price.id_currency, 10) && combination.specific_price.id_currency !== currency.id) {
                        reduction /= currencyRate;
                    }
                    else if (!specific_currency) {
                        reduction *= currencyRate;
                    }

                    if (typeof groupReduction !== 'undefined' && groupReduction > 0) {
                        reduction *= 1 - parseFloat(groupReduction);
                    }

                    this.priceWithDiscountsDisplay -= reduction;
                    // We recalculate the price without tax in order to keep the data consistency
                    priceWithDiscountsWithoutTax = this.priceWithDiscountsDisplay - (reduction * (1 / (1 + (taxRate / 100))));
                }
            }
        }

        if (this.priceWithDiscountsDisplay < 0) {
            this.priceWithDiscountsDisplay = 0;
        }

        if (this.basePriceDisplay !== this.priceWithDiscountsDisplay) {
            discountValue = this.basePriceDisplay - this.priceWithDiscountsDisplay;
            discountPercentage = (1 - (this.priceWithDiscountsDisplay / this.basePriceDisplay)) * 100;
        }

        const unit_impact = +combination.unit_impact;
        if (productUnitPriceRatio > 0 || unit_impact) {
            if (unit_impact) {
                baseUnitPrice = productBasePriceTaxExcl / productUnitPriceRatio;
                unit_price = baseUnitPrice + unit_impact;

                if (!noTaxForThisProduct || !customerGroupWithoutTax) {
                    unit_price *= (taxRate / 100 + 1);
                }

            }
            else {
                unit_price = this.priceWithDiscountsDisplay / productUnitPriceRatio;
            }
        }

        $('#old_price, #old_price_display, #old_price_display_taxes').hide();
        $('.price-ecotax').hide();
        $('.unit-price').hide();
        $('.plusfreeshipping').hide();

        if (this.priceWithDiscountsDisplay > 0) {
            $('#our_price_display').text(tools.formatCurrency(this.priceWithDiscountsDisplay, currencyFormat, currencySign, currencyBlank)).trigger(change);
        }
        else {
            $('#our_price_display').text(tools.formatCurrency(0, currencyFormat, currencySign, currencyBlank)).trigger(change);
        }

        const $percent = $('#reduction_percent');
        const $amount = $('#reduction_amount');

        if (this.priceWithDiscountsDisplay.toFixed(2) != this.basePriceDisplay.toFixed(2)) {
            $('#old_price_display span.price').text(tools.formatCurrency(this.basePriceDisplay, currencyFormat, currencySign, currencyBlank));
            $('#old_price, #old_price_display, #old_price_display_taxes').removeClass('hidden').show();

            if (priceWithDiscountsWithoutTax != priceWithGroupReductionWithoutTax) {
                if (combination.specific_price.reduction_type == 'amount') {
                    $('#reduction_amount_display').html(`-${tools.formatCurrency(discountValue, currencyFormat, currencySign, currencyBlank)}`);
                    setTimeout(() => {
                        $amount.show();
                    }, this.galleryFadeSpeed);

                }
                else {
                    const toFix = (parseFloat(discountPercentage).toFixed(2) - parseFloat(discountPercentage).toFixed(0)) ? 0 : 2;
                    $('#reduction_percent_display').html(`${parseFloat(discountPercentage).toFixed(0)}%`);
                //    $('#reduction_percent_display').html(`<span class="sale-label sale-label-black-friday"><div class="sale-label-black-friday-text">CYBER<div class="sale-label-black-friday-text-bold">WEEK</div></div><div class="sale-label-black-friday-discount">${parseFloat(discountPercentage).toFixed(0)}%</div> </span>`);
                    setTimeout(() => {
                        $percent.show();
                    }, this.galleryFadeSpeed);
                }
            }
        }
        else {
            setTimeout(() => {
                $percent.hide();
                $amount.hide();
            }, this.galleryFadeSpeed);
        }

        if (default_eco_tax) {
            ecotax = default_eco_tax;

            if (combination.ecotax) {
                ecotax = +combination.ecotax;
            }

            if (!noTaxForThisProduct) {
                ecotax *= (1 + ecotaxTax_rate / 100);
            }

            $('#ecotax_price_display').text(tools.formatCurrency(ecotax * currencyRate, currencyFormat, currencySign, currencyBlank));
            $('.price-ecotax').show();
        }

        if (productUnitPriceRatio > 0) {
            $('#unit_price_display').text(tools.formatCurrency(unit_price, currencyFormat, currencySign, currencyBlank));
            $('.unit-price').show();
        }

        if (this.priceWithDiscountsDisplay >= minPriceToFreeShip) {
            $('.plusfreeshipping').show();
        }


        this.setAttributePrices();
    }

    saveCustomization() {
        $('#quantityBackup').val($('#quantity_wanted').val());
        $('#customizationForm').submit();
    }

    submitPublishProduct(url, redirect, token) {
        const id_product = $('#admin-action-product-id').val();

        $.ajaxSetup({ async: false });
        $.post(
            `${url}/index.php`, {
                action: 'publishProduct',
                id_product,
                status: 1,
                redirect,
                ajax: 1,
                tab: 'AdminProducts',
                token
            },
            data => {
                if (data.indexOf('error') === -1) {
                    document.location.href = data;
                }
            }
        );
        return true;
    }

    checkMinimalQuantity(minimal_quantity) {
        if ($('#quantity_wanted').val() < minimal_quantity) {
            $('#quantity_wanted').css('border', '1px solid red');
            $('#minimal_quantity_wanted_p').css('color', 'red');
        }
        else {
            $('#quantity_wanted').css('border', '1px solid #BDC2C9');
            $('#minimal_quantity_wanted_p').css('color', '#374853');
        }
    }

    checkUrl() {

        try {
            const idCombination = parseInt(window.location.search.match(/combination=(\d+)/)[1], 10);
            const combination = combinations.find(cmb => idCombination == cmb.idCombination);
            const attributes = combination.idsAttributes;

            for (const idAttribute of attributes) {
                const attribute = attributesCombinations.find(attr => attr.id_attribute == idAttribute);
                const idAttributeGroup = attribute.id_attribute_group;


                $(`#color_${idAttribute}`).addClass('selected').parent().addClass('selected');
                $(`input:radio[value=${idAttribute}]`).prop('checked', true);
                $(`input[type=hidden][name=group_${idAttributeGroup}]`).val(idAttribute);
                $(`select[name=group_${idAttributeGroup}]`).val(idAttribute);

                const $attr = $(`.kli_attr[data-attribute="${idAttribute}"]`);
                $attr
                    .addClass('selected')
                    .siblings()
                    .removeClass('selected');

            }

        }
        catch (err) {
            //             console.log(err);
        }
        return false;
    }

    responsive() {
        let oldWidth = -1;
        $window.on('resize', () => {
            if (oldWidth !== window.innerWidth) {
                oldWidth = window.innerWidth;

                this.initColors();

                (function (doc) {
                    const attributes = doc.querySelectorAll('.attribute_type_select .kli_attr');
                    for (let i = 0; i < attributes.length; i++) {
                        try {
                            const outter = attributes[i];
                            const outterHeight = outter.offsetHeight - 5;
                            const inner = outter.querySelector('.kainaAtributo');
                            let innerHeight = inner.getBoundingClientRect().height;
                            const value = inner.querySelector('.value-attributo-inner');
                            let count = 0;
                            while (outterHeight <= innerHeight) {
                                let fontSize = parseInt(value.style.fontSize, 10);
                                if (isNaN(fontSize)) {
                                    fontSize = 16;
                                }
                                value.style.fontSize = `${fontSize - 1}px`;
                                innerHeight = inner.getBoundingClientRect().height;
                                count++;
                                if (count > 16) {
                                    break;
                                }
                            }
                        }
                        catch (e) {
                            //
                        }
                    }
                }(document));
            }
        });
        this.initColors();
    }

    collapsables() {
        $document.on(click, '[data-toggle="klip_collapse"]', function (e) {
            e.preventDefault();
            const $this = $(this);
            const $target = $($this.data('target'));
            const status = $target.hasClass('klip-collapsed');

            $target
                .toggleClass('klip-collapsed', !status)
                .velocity('finish')
                .velocity((status ? 'slideUp' : 'slideDown'), {
                    duration: 400
                });
        });
    }

    updateColorSelect() {
        const $colorToPickList = this.$colorToPick;
        let $select = $('#color-search');

        if (!$select.length) {
            let $colorSearch = $colorToPickList.nextAll('.color-search');

            if (!$colorSearch.length) {
                $colorSearch = $('<div class="color-search "></div>');
                $colorToPickList.before($colorSearch);
            }

            $select = $('<select name="xxx" id="color-search"></select>');
            $colorSearch.append($select);
        }
        if (!$select.data('select2')) {
            var count=0;
            $colorToPickList.find('.kli_attr').each((i, el) => {
                const $this = $(el);
                $select.append(`<option value="${$this.data('attribute')}" data-stock="${$this.attr('data-stock')}" data-style="${$this.find('.color_pick').attr('style')}">${KLIP_COLOR}: ${$this.data('color-name')}</option>`);
                count=i;
            });
            $('.color-comb-count').html(count+1);
            $select.select2({
                minimumResultsForSearch: Infinity,
                templateResult: this.formatColorsSelectOption,
                templateSelection: this.formatColorsSelectSelection,
                dropdownParent: $('#dropdownParent'),
            });
            // $select.on('select2:open', function () {
            // });
            $select.on('change.attribute', e => {
                const $attribute = $colorToPickList.find(`span[data-attribute='${e.currentTarget.value}']`);
                if (!$attribute.hasClass('selected')) {
                    $attribute.trigger(click);
                }
            });
        }

        const id_attribute = $colorToPickList.find('.kli_attr.selected').data('attribute');
        if (id_attribute != $select.val()) {
            $select.val(id_attribute).trigger(change);
        }

    }

    formatColorsSelectOption(optionElement) {
        if (!optionElement.id) {
            return optionElement.text;
        }
        const text = optionElement.text;
        const res = text.split(':');
        const stock = optionElement.element.getAttribute('data-stock');
        const color = optionElement.element.getAttribute('data-style');
        let stock_text=inStock;
        if (stock=='0') {
            stock_text=outOfStock;
        }
        if (stock=='1' && $('#last_quantities').length) {
            stock_text=$('#last_quantities').html();
        }
        const $state = $(`<div class="block-color"><div class="acolor" style="${color}"></div><div class="text-block"><span><strong>${res[0]}:` + `</strong> ${res[1]}</span><br /><span class="astock${stock}">${stock_text}</span></div></div>`);
        return $state;
    }

    formatColorsSelectSelection(optionElement) {
        if (!optionElement.id) {
            return optionElement.text;
        }
        const text = optionElement.text;
        const res = text.split(':');
        const stock = optionElement.element.getAttribute('data-stock');
        const color = optionElement.element.getAttribute('data-style');
        let stock_text=inStock;
        if (stock=='0') {
            stock_text=outOfStock;
        }
        if (stock=='1') {
            stock_text=$('#last_quantities').html();
        }
        const $state = $(`<div class="block-color"><div class="acolor" style="${color}"></div><div class="text-block"><span><strong>${res[0]}:` + `</strong> ${res[1]}</span><br /><span class="astock${stock}">${stock_text}</span></div></div>`);
        return $state;
    }

    changeQuantity(direction = 0) {
        const $quantityWanted = $('#quantity_wanted');
        let value = parseInt($quantityWanted.val(), 10) + direction;

        if(value < 2){
            $('.quantity-down').addClass('quantity-down-non-active');
        }else{
            $('.quantity-down').removeClass('quantity-down-non-active');
        }

        const max = this.selectedCombination.quantity;
        value = value > max ? max : value;
        value = value < 1 ? 1 : value;
        $quantityWanted.val(value);
    }

    submitStockSubscribtion(e) {
        e.preventDefault();
        const product_id = $('[name=atcfn-product]').val();
        const attribute_id = $('[name=atcfn-attribute]').val();
        const email = $('[name=arcfn-email]').val();
        const newsletter = true;
        const $form = $('#atcfn-form');
        const $error = $('.atcfn-helper.error');
        const $submit = $('.arcfn-submit');

        $.ajax({
            type: 'POST',
            url: `${baseDir}modules/quantityemail/ajax.php`,
            data: {
                product_id,
                attribute_id,
                email,
                newsletter
            },
            beforeSend: () => {
                $submit.spinner('start');
                $form.removeClass('haserror');
                $form.removeClass('hassuccess');
            },
            success: data => {
                $submit.spinner('stop');
                switch (data) {
                    case '01':
                        $form.addClass('haserror');
                        $error.html(KLIP_P_WRONG_EMAIL);
                        break;
                    case '02':
                        $form.addClass('haserror');
                        $error.html(KLIP_P_SQL_ERROR);
                        break;
                    case '03':
                        $form.addClass('haserror');
                        $error.html(KLIP_P_ALREADY_IN_DB);
                        break;
                    case '1':
                        $form.addClass('hassuccess');
                        $('[name="arcfn-email"]').html('').val('');
                        $('.atcfn-helper.success').html(KLIP_P_SUCCESS);
                        break;
                    default:
                }


            },
            error: () => {
                $submit.spinner('stop');
                $form.addClass('haserror');
            }
        });
    }


    initColors() {
        // Collect Data
        if (!this.$colorToPick.length) {
            return;
        }
        this.changeAvailableCombinations();
    }


    iniParfumSelect(){
        $("#perfumeBox").select2({
            templateResult: perfumeBoxSelect2,
            templateSelection: perfumeBoxSelectDefault2,
            minimumResultsForSearch: 22,
            width: '100%',
        });
        $('#perfumeBox-content').show();
    }



}


function perfumeBoxSelectDefault2 (select) {
    if (!select.id) { return select.text; }
    var $currency = $('<div><span class="select2-text-name">Pakuotė: </span>'+select.text+'</div>');
    return $currency;
};

function perfumeBoxSelect2 (select) {
    if (!select.id) { return select.text; }
    if(select.element.attributes['data-info'].value != ''){
        var add = '<span class="select2-text-info"><br/>'+select.element.attributes['data-info'].value+'</span>';
    }else{
        var add = '';
    }
    var $currency = $('<div><span class="select2-text-name">Pakuotė: </span>'+select.text+add+'</div>');
    return $currency;
};


function previousImage() {
    currentImg = Math.max(currentImg - 1, 0);
    scrollImages(IMG_WIDTH * currentImg, speed);
}

function nextImage() {
    currentImg = Math.min(currentImg + 1, maxImages - 1);
    scrollImages(IMG_WIDTH * currentImg, speed);
}

/**
 * Manually update the position of the imgs on drag
 */
function scrollImages(distance, duration) {

    if(maxImages<2){
        return;
    }

    $('body').css('overflow','hidden');

    imgs.css("transition-duration", (duration / 1000).toFixed(1) + "s");

    //inverse the number we set in the css
    var value = (distance < 0 ? "" : "-") + Math.abs(distance).toString();
    imgs.css("transform", "translate(" + value + "px,0)");
}



function swipeHandler(event, side) {
    var curent = parseInt($('.product-gallery-content').attr('data-noblock'));

    if(maxImages >= curent){
        if (side == 'left'){
            var curent = curent + 1;
        } else{
            var curent = curent - 1;
        }
    }

    if(curent > maxImages){
        var curent = maxImages;
    }

    if(curent < 1){
        var curent = 1;
    }

    $('.product-gallery-content').attr('data-noblock',curent.toString());

    if ($('.dots-item-no_' + curent.toString()).length > 0){
        $('.dots-item').removeClass('dots-active');
        $('.dots-item-no_'+curent.toString()).addClass('dots-active');
    }


}


vars.product = new Product();

export default vars.product;
